import layout from '../layout'
export default function makeUserFreeRoutes({
  contentType,
  components: { UserFreeListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/free-users/list/`,
          component: UserFreeListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
